export default "__VITE_ASSET__7u6mLtxK__"